import { RootState } from '..';
import {SessionsState} from './types';
import {createSelector} from "reselect";

const sessionsSelector: (state: RootState) => SessionsState = (state: RootState) => state.sessions;

export const selectSessions = createSelector(sessionsSelector, (items => {
    return items.sessions;
}))
